import React, { lazy } from 'react'
import { Route, Switch, useRouteMatch } from '@fs/zion-router'

const LandingPage = lazy(() => import('./LandingPage/LandingPage'))

export default function Router(): JSX.Element {
  const { path } = useRouteMatch()

  return (
    <Switch>
      <Route component={LandingPage} path={`${path}/`} />
    </Switch>
  )
}
